module.exports = __webpack_public_path__ + "img/ransomware.e89cfe4f.png";